"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9948],{

/***/ 79948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65218);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20368);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79758);
/* harmony import */ var hooks_useCookieSettings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34457);





function CookieBanner() {
    var ref = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_2__/* .useSiteConfig */ .N)(), cookieConsent = ref.cookieConsent, oneTrustApiKey = ref.env.oneTrustApiKey;
    var setShowingCookieBannerOT = (0,hooks_useCookieSettings__WEBPACK_IMPORTED_MODULE_4__/* .useCookieSettings */ .eK)().setShowingCookieBannerOT;
    var ref1;
    var _cookieConsentProvider = (ref1 = cookieConsent === null || cookieConsent === void 0 ? void 0 : cookieConsent.provider) !== null && ref1 !== void 0 ? ref1 : "Google";
    var _cookieConsentApiKey = oneTrustApiKey !== null && oneTrustApiKey !== void 0 ? oneTrustApiKey : "";
    var ref2;
    var _cookieConsentDocumentLanguage = (ref2 = cookieConsent === null || cookieConsent === void 0 ? void 0 : cookieConsent.documentLanguage) !== null && ref2 !== void 0 ? ref2 : false;
    var _$CookieBanner;
    switch(_cookieConsentProvider){
        case "OneTrust":
            _$CookieBanner = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
                return __webpack_require__.e(/* import() */ 9321).then(__webpack_require__.bind(__webpack_require__, 59321));
            }, {
                loadableGenerated: {
                    webpack: function() {
                        return [
                            /*require.resolve*/(59321)
                        ];
                    }
                },
                ssr: false
            });
            break;
        case "Google":
        default:
            _$CookieBanner = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
                return __webpack_require__.e(/* import() */ 5223).then(__webpack_require__.bind(__webpack_require__, 55223));
            }, {
                loadableGenerated: {
                    webpack: function() {
                        return [
                            /*require.resolve*/(55223)
                        ];
                    }
                },
                ssr: false
            });
            break;
    }
    var triggerConsentEvent = function() {
        var event = new Event(utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .COOKIE_BANNER_ACKNOWLEDGED_EVENT_NAME */ .p5);
        window.dispatchEvent(event);
        setShowingCookieBannerOT(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_$CookieBanner, {
        apiKey: _cookieConsentApiKey,
        documentLanguage: _cookieConsentDocumentLanguage,
        triggerConsentEvent: triggerConsentEvent
    });
}
/* harmony default export */ __webpack_exports__["default"] = (CookieBanner);


/***/ })

}]);